import React from 'react';

import Panel from 'buyside/components/presentation/Feed/CorporateAction/Panel/panel';

import { entityUrl, assetUrl } from 'buyside/util/urlHelper';

const PanelWithHeading = ({
  title,
  entity,
  asset,
  preActionPrice,
  postActionPrice,
  actionPeriodReturn,
  timeframe = '30'
}) => {
  const name = asset ? asset.name : entity.name;
  const url = asset ? assetUrl(asset.fsPermSecId) : entityUrl(entity.id);
  const symbol = asset ? asset.symbol : entity.primarySymbol;
  return (
    <div>
      {title && <h5>{title}</h5>}
      <Panel
        header={name}
        headerUrl={url}
        symbol={symbol}
        tableData={[
          { label: `Price ${timeframe} days prior`, data: preActionPrice },
          { label: 'Price 1 day prior', data: postActionPrice },
          {
            label: `${timeframe}-day Trailing Return`,
            data: actionPeriodReturn,
            isReturn: true
          }
        ]}
      />
    </div>
  );
};

export default PanelWithHeading;
